import { Box } from "@mui/material";

interface LotOfferImageProps {
  url: string;
}

export default function LotOfferBigImage({ url }: LotOfferImageProps) {
  return (
    <Box
      component="div"
      sx={{
        display: "flex",
        overflow: "hidden",
        maxWidth: "500px",
        width: "auto",
        justifyContent: "center",
        height: "auto",
      }}
    >
      <Box
        component="img"
        src={url}
        alt="Bild eines HolzPolters"
        sx={{
          aspectRatio: "16/9",
          maxWidth: "500px",
          maxHeight: "400px",
          width: "auto",
          height: "auto",
          objectFit: "cover",
          objectPosition: "left",
        }}
      />
    </Box>
  );
}
